module.exports = __webpack_public_path__ + "offer-attribute.svg?9a39f5536d9d9b9a2a2d8d86841f91f7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/offer-attribute.svg
// module id = 302
// module chunks = 2